import React, { useEffect, useState } from "react";
// import imgs from "../../assets/image6.webp";
// import card1 from "../../assets/card1.png";
// import card2 from "../../assets/card2.png";
// import card3 from "../../assets/card3.png";
// import card4 from "../../assets/card4.png";
// import card4 from "../../assets/card4.png";
import Carousel from "better-react-carousel";
import { toast, ToastContainer } from "react-toastify";

import { Swiper, SwiperSlide } from "swiper/react";
import { ApiCall, Web_url } from "../../common/Const";
import { useNavigate } from "react-router-dom";
import { color } from "@mui/system";

const Card = ({ collections, cusId }) => {
  const navigate = useNavigate();
  const [favIcon, setfavIcon] = useState(0);
  const [favprId,setFavId] = useState([]);

  // const details = [
  //   {
  //     id: "1",
  //     images: card1,
  //     title: "Loremispum",
  //     actural_price: 25000,
  //     offer_price: 20000,
  //     offer: "10% Offer",
  //   },
  //   {
  //     id: "2",
  //     images: card2,
  //     title: "Loremispum",
  //     actural_price: 25000,
  //     offer_price: 20000,
  //     offer: "10% Offer",
  //   },
  //   {
  //     id: "3",
  //     images: card3,
  //     title: "Loremispum",
  //     actural_price: 25000,
  //     offer_price: 20000,
  //     offer: "10% Offer",
  //   },
  //   {
  //     id: "4",
  //     images: card4,
  //     title: "Loremispum",
  //     actural_price: 25000,
  //     offer_price: 20000,
  //     offer: "10% Offer",
  //   },
  //   {
  //     id: "5",
  //     images: card4,
  //     title: "Loremispum",
  //     actural_price: 25000,
  //     offer_price: 20000,
  //     offer: "10% Offer",
  //   },
  //   {
  //     id: "6",
  //     images: card1,
  //     title: "Loremispum",
  //     actural_price: 25000,
  //     offer_price: 20000,
  //     offer: "10% Offer",
  //   },
  //   {
  //     id: "7",
  //     images: card2,
  //     title: "Loremispum",
  //     actural_price: 25000,
  //     offer_price: 20000,
  //     offer: "10% Offer",
  //   },
  //   {
  //     id: "8",
  //     images: card3,
  //     title: "Loremispum",
  //     actural_price: 25000,
  //     offer_price: 20000,
  //     offer: "10% Offer",
  //   },
  //   {
  //     id: "9",
  //     images: card4,
  //     title: "Loremispum",
  //     actural_price: 25000,
  //     offer_price: 20000,
  //     offer: "10% Offer",
  //   },
  //   {
  //     id: "10",
  //     images: card4,
  //     title: "Loremispum",
  //     actural_price: 25000,
  //     offer_price: 20000,
  //     offer: "10% Offer",
  //   },
  //   {
  //     id: "11",
  //     images: card4,
  //     title: "Loremispum",
  //     actural_price: 25000,
  //     offer_price: 20000,
  //     offer: "10% Offer",
  //   },
  //   {
  //     id: "12",
  //     images: card4,
  //     title: "Loremispum",
  //     actural_price: 25000,
  //     offer_price: 20000,
  //     offer: "10% Offer",
  //   },
  // ];
  const handleClick = (data) => {
    console.log("---->", data);
    navigate("/product-details", { state: { p_detail: data } });
  };
  const texts = [
    {
      id: 1,
      head: "Theni Kamadhenu Collections",
      para: "Loremipsum dolor sit amet, consectetur adipiscing elit. Curabitur quis elit bibendum, posuere velit nec, placerat magna. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nulla vulputate suscipit diam at congue. Aliquam sit amet elit lacus. Aliquam eget velit faucibus, lacinia tellus vitae, posuere felis. Vestibulum sit amet pulvinar ligula. Morbi ante lacus, tincidunt in purus non, fringilla ornare metus. Duis blandit urna non pretium maximus. Sed lacus arcu, convallis eu ex et, volutpat aliquet turpis.",
    },
    {
      id: 2,
      head: "Trend Inspired",
      para: "Loremipsum dolor sit amet, consectetur adipiscing elit. Curabitur quis elit bibendum, posuere velit nec, placerat magna. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nulla vulputate suscipit diam at congue. Aliquam sit amet elit lacus. Aliquam eget velit faucibus, lacinia tellus vitae, posuere felis. Vestibulum sit amet pulvinar ligula. Morbi ante lacus, tincidunt in purus non, fringilla ornare metus. Duis blandit urna non pretium maximus. Sed lacus arcu, convallis eu ex et, volutpat aliquet turpis.",
    },
    {
      id: 3,
      head: "List Collections",
      para: "Loremipsum dolor sit amet, consectetur adipiscing elit. Curabitur quis elit bibendum, posuere velit nec, placerat magna. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nulla vulputate suscipit diam at congue. Aliquam sit amet elit lacus. Aliquam eget velit faucibus, lacinia tellus vitae, posuere felis. Vestibulum sit amet pulvinar ligula. Morbi ante lacus, tincidunt in purus non, fringilla ornare metus. Duis blandit urna non pretium maximus. Sed lacus arcu, convallis eu ex et, volutpat aliquet turpis.",
    },
  ];
  const additemToFav = (id) => {
    
     var favParams = { customer_id: cusId, product_id: id };
     console.log(favParams, "favParams");

     if(favIcon == 0){
      console.log('slfksjdlfsj')
          ApiCall("addFav", favParams)
            .then((data) => {
              console.log("adeed");
              if (data.message == "Success") {
                setfavIcon(1);
                toast.success("Favourite added", {
                  position: "top-right",
                  autoClose: 3000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "colored",
                });
              } else {
              }
            })
            .catch((err) => console.log(err));
     }
     else{
      console.log('kslfksd');
      ApiCall("removeFav", favParams)
        .then((data) => {
          console.log("adeed");
          if (data.message == "Success") {
            setfavIcon(0);
            toast.success("Favourite Removed", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          } else {
          }
        })
        .catch((err) => console.log(err));
     }

        
  };

  // const removeToFav = (id) => {
  //   var favParams = { customer_id: cusId, product_id: id };
  //   console.log(favParams, "favParams");
  //   ApiCall("removeFav", favParams)
  //     .then((data) => {
  //       console.log("adeed");
  //       if (data.message == "Success") {
  //         setfavIcon(1);
  //         toast.success("Favourite added", {
  //           position: "top-right",
  //           autoClose: 3000,
  //           hideProgressBar: false,
  //           closeOnClick: true,
  //           pauseOnHover: true,
  //           draggable: true,
  //           progress: undefined,
  //           theme: "colored",
  //         });
  //       } else {
  //       }
  //     })
  //     .catch((err) => console.log(err));
  // };
  console.log(collections,"sak");
  return (
    <div>
      <h3 className="mb-4 other-c-heading">Other Collections</h3>
      <div className="container-fluid mt-5  ">
        <div className="row ">
          <Carousel
            cols={5}
            rows={2}
            gap={30}
            mobileBreakpoint
            arrowLeft={
              <button
                type="prev"
                className="btn left-arrow"
                style={{ backgroundColor: "#126a38", color: "white" }}
              >
                <i
                  class="fa-solid fa-play"
                  style={{ transform: "rotate(180deg)" }}
                ></i>
              </button>
            }
            arrowRight={
              <button
                type="next"
                className="btn right-arrow"
                style={{ backgroundColor: "#126a38", color: "white" }}
              >
                <i class="fa-solid fa-play"></i>
              </button>
            }
            responsiveLayout={[
              { breakpoint: 1280, cols: 3, rows: 2, gap: 10, loop: true },
              { breakpoint: 800, cols: 3, rows: 2, gap: 10, loop: true },
              { breakpoint: 1024, cols: 3, rows: 2, gap: 10, loop: true },
              { breakpoint: 412, cols: 2 },
              { breakpoint: 415, cols: 1 },
              { breakpoint: 376, cols: 1 },
              { breakpoint: 281, col: 1 },
              { breakpoint: 394, col: 1 },
              { breakpoint: 391, col: 1 },
              { breakpoint: 361, col: 1 },
            ]}
            scrollSnap
            loop
          >
            {collections.result.map((items) => {
              return (
                <Carousel.Item>
                  {/* <div className="col-12 col-lg-3 col-md-3 "> */}
                  <div
                    className="card top-card "
                    onClick={() => handleClick(items)}
                  >
                    {items.fav_status == 1 ? (
                      <i
                        class="fa-sharp fa-solid fa-heart d-flex justify-content-end pt-3 pe-3"
                        style={{ color: "#126a38" }}
                        onClick={() => additemToFav(items.product_id)}
                      ></i>
                    ) : (
                      <i
                        class="fa-regular fa-heart d-flex justify-content-end pt-3 pe-3"
                        onClick={() => additemToFav(items.product_id)}
                      ></i>
                    )}
                    <img
                      src={Web_url.Domain_url + items.product_image[0].url}
                      class="carslimg"
                      alt="..."
                      width="100%"
                      height="190"
                    ></img>
                    <div class="card-body cbody">
                      <small class="card-title" style={{ color: "#126a38" }}>
                        {items.product_name}
                      </small>{" "}
                      <br />
                      <small className="card-rates">
                        ₹{items.varient[0].offer_price}
                      </small>{" "}
                      <small
                        style={{ fontSize: "18px" }}
                        className="card-rates-title text-muted"
                      >
                        ₹{items.varient[0].actual_price}
                      </small>{" "}
                      <br />
                      <small style={{ color: "#126a38" }} className="offer">
                        {items.discount}%offer
                      </small>
                    </div>
                    {/* </div> */}
                  </div>
                </Carousel.Item>
              );
            })}
          </Carousel>
        </div>
        <div className="d-flex gap-2 justify-content-center pt-5 pb-5 left-right-bttn">
          {/* <span
            type="prev"
            className="btn ArrowButton__Button-sc-1ikb0hj-1"
            style={{ backgroundColor: "#126a38", color: "white" }}
          >
            <i
              class="fa-solid fa-play"
              style={{ transform: "rotate(180deg)" }}
            ></i>
          </span>
          <button
            type="next"
            className="btn ArrowButton__Button-sc-1ikb0hj-1"
            style={{ backgroundColor: "#126a38", color: "white" }}
          >
            <i class="fa-solid fa-play"></i>
          </button> */}
        </div>
      </div>
      <div className="collections-text mb-5">
        {texts.map((texts) => {
          return (
            <div className="j-collections mb-5 ">
              <h3
                className="mb-4"
                style={{ color: "#126a38", fontWeight: "50" }}
              >
                {texts.head}
              </h3>
              <p>{texts.para}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default Card;
